const STORAGE_KEY = "kairo.pendingInvite";

type StoredInvite = {
  code: string;
  type?: string | null;
};

function isBrowserEnvironment(): boolean {
  return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
}

export function setPendingInvite(invite: StoredInvite): void {
  if (!isBrowserEnvironment()) return;

  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(invite));
  } catch (error) {
    console.warn("workspace-invite: failed to persist pending invite", error);
  }
}

export function getPendingInvite(): StoredInvite | null {
  if (!isBrowserEnvironment()) return null;

  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;

    const parsed = JSON.parse(raw) as Partial<StoredInvite> | null;
    if (!parsed || typeof parsed.code !== "string") {
      return null;
    }

    const code = parsed.code.trim();
    if (code.length === 0) {
      return null;
    }

    return {
      code,
      type: parsed.type ?? null,
    };
  } catch (error) {
    console.warn("workspace-invite: failed to read pending invite", error);
    return null;
  }
}

export function clearPendingInvite(): void {
  if (!isBrowserEnvironment()) return;

  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch (error) {
    console.warn("workspace-invite: failed to clear pending invite", error);
  }
}
